import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ title, value, subtitle, trend, trendValue, icon, iconColor, onClick, tooltip }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const getTrendColor = () => {
    if (!trend) return 'text-muted-foreground';
    if (trend === 'neutral') return 'text-muted-foreground';
    return trend === 'up' ? 'text-success' : 'text-error';
  };

  const getTrendIcon = () => {
    if (!trend || trend === 'neutral') return null;
    return trend === 'up' ? 'TrendingUp' : 'TrendingDown';
  };

  return (
    <div
      className={`bg-card border border-border rounded-lg p-4 md:p-6 transition-smooth hover:shadow-elevation-md ${
        onClick ? 'cursor-pointer' : ''
      }`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-1.5 mb-1">
            <p className="caption text-muted-foreground">{title}</p>
            {tooltip && (
              <div className="relative" onClick={e => e.stopPropagation()}>
                <button
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  onFocus={() => setShowTooltip(true)}
                  onBlur={() => setShowTooltip(false)}
                  className="text-muted-foreground hover:text-foreground transition-colors"
                  aria-label={`About ${title}`}
                >
                  <Icon name="HelpCircle" size={12} />
                </button>
                {showTooltip && (
                  <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-50 w-64 bg-popover border border-border rounded-lg shadow-elevation-lg p-3 pointer-events-none">
                    <p className="text-xs text-popover-foreground leading-relaxed whitespace-pre-line">{tooltip}</p>
                    <div className="absolute top-full left-1/2 -translate-x-1/2 w-2 h-2 bg-popover border-r border-b border-border rotate-45 -mt-1" />
                  </div>
                )}
              </div>
            )}
          </div>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground">
            {value}
          </h3>
        </div>
        <div
          className={`flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg ${iconColor}`}
        >
          <Icon name={icon} size={20} color="#FFFFFF" />
        </div>
      </div>

      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">{subtitle}</p>
        {trend && trend !== 'neutral' && trendValue && (
          <span className={`text-sm font-medium ${getTrendColor()}`}>{trendValue}</span>
        )}
        {trend === 'neutral' && trendValue && (
          <span className="text-sm font-medium text-muted-foreground">{trendValue}</span>
        )}
      </div>
    </div>
  );
};

export default KPICard;